import { VatPayerValue } from "../enums/vatpayer-value.enum";

export class VatPayerOptions {
    public static vatPayer = [
        { value: 'Y', name: VatPayerValue.YES},
        { value: 'N', name: VatPayerValue.NO }
    ];
}


// WEBPACK FOOTER //
// ./src/app/common/constants/vatpayer-options.constants.ts